import { createSelector } from 'reselect';

const listsSelector = state => state.list.lists;

export const getLists = createSelector(
    listsSelector,
    lists => lists,
);
